<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div
          v-if="formData.renewal_letter_insurer"
          class="form-item tr">
          <span>Renewal Letter（Insurer）</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.renewal_letter_insurer" />
        </div>
        <div class="form-item tr">
          <span>Policyholder HKID</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.id_type_pic" />
        </div>
        <div
          v-if="formData.nm_pa_list && formData.nm_pa_list.length > 0"
        >
          <div
            v-for="(item,index) in formData.nm_pa_list"
            :key="index"
            class="form-item tr">
            <div>Insured  {{index+1}}</div>
            <file-container
              :key="index"
              is-show-detail
              is-viewer
              :fileData="{
                url:item.id_type_pic_url,
                thumb_url:item.id_type_pic_url,
                client_name:item.id_type_pic_path_id}"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'HousemaidDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
